module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('meta', {
    attrs: {
      "content": "text/html; charset=utf-8",
      "http-equiv": "Content-Type"
    }
  }), _vm._v(" "), _c('title', [_vm._v("Remembering Farley")]), _vm._v(" "), _c('link', {
    attrs: {
      "href": "style.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "textn"
  }), _vm._v(" "), _c('p', {
    staticClass: "textn"
  }), _vm._v(" "), _c('p', {
    staticClass: "textn"
  }), _vm._v(" "), _c('p', {
    staticClass: "textn"
  }, [_vm._v("In my life, the question has gone from “How does\n  Mom know?”")]), _vm._v(" "), _c('p', {
    staticClass: "textn"
  }, [_vm._v("to the more horrifying: “How much more does Mom\nknow that I don’t know she knows?”")]), _vm._v(" "), _c('p', {
    staticClass: "textn"
  }, [_vm._v("to the truly baffling: “How much more could there\npossibly be to find out?”")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("It turns out, quite a lot.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9dfe8ac0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mom028.vue
// module id = 135
// module chunks = 0